var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c("modal-pop", {
        staticClass: "modal",
        attrs: {
          opened: _vm.$store.state.auth.manageFido.fidoPop.pincodeChg.isOpen,
          "modal-header": true,
          "modal-footer": true,
          "btn-close": true,
          title: "MLGI-07-01-03-01"
        },
        on: {
          "update:opened": function($event) {
            return _vm.$set(
              _vm.$store.state.auth.manageFido.fidoPop.pincodeChg,
              "isOpen",
              $event
            )
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.$t("MLGI-07-01-03-02")) }
                  })
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: { click: _vm.FN001 }
                  },
                  [
                    _vm._v(
                      _vm._s(/*인증 번호 변경*/ _vm.$t("MLGI-07-01-03-03"))
                    )
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: { click: _vm.FN002 }
                  },
                  [
                    _vm._v(
                      _vm._s(/*간편 인증 해제*/ _vm.$t("MLGI-07-01-03-04"))
                    )
                  ]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("modal-pop", {
        staticClass: "modal",
        attrs: {
          opened:
            _vm.$store.state.auth.manageFido.fidoPop.pincodeConfirm.isOpen,
          "modal-header": true,
          "modal-footer": true,
          "btn-close": true,
          title: "MLGI-07-01-04-01"
        },
        on: {
          "update:opened": function($event) {
            return _vm.$set(
              _vm.$store.state.auth.manageFido.fidoPop.pincodeConfirm,
              "isOpen",
              $event
            )
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.$t("MLGI-07-01-04-02")) }
                  })
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom negative",
                    on: { click: _vm.FN003 }
                  },
                  [_vm._v(_vm._s(/*아니오*/ _vm.$t("MCOM-0000005")))]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: { click: _vm.FN004 }
                  },
                  [_vm._v(_vm._s(/*예*/ _vm.$t("MCOM-0000006")))]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("modal-pop", {
        staticClass: "modal",
        attrs: {
          opened:
            _vm.$store.state.auth.manageFido.fidoPop.fingerprintConfirm.isOpen,
          "modal-header": true,
          "modal-footer": true,
          "btn-close": true,
          title:
            _vm.$store.state.native.biometryTypeIos === "faceId"
              ? "MLGI-07-01-04-09"
              : "MLGI-07-01-04-05"
        },
        on: {
          "update:opened": function($event) {
            return _vm.$set(
              _vm.$store.state.auth.manageFido.fidoPop.fingerprintConfirm,
              "isOpen",
              $event
            )
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", [
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          _vm.$store.state.native.biometryTypeIos === "faceId"
                            ? "MLGI-07-01-04-10"
                            : "MLGI-07-01-04-06"
                        )
                      )
                    }
                  })
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom negative",
                    on: { click: _vm.FN005 }
                  },
                  [_vm._v(_vm._s(/*아니오*/ _vm.$t("MCOM-0000005")))]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: { click: _vm.FN006 }
                  },
                  [_vm._v(_vm._s(/*예*/ _vm.$t("MCOM-0000006")))]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }